/** tempexp_14728-full-file */
import { Icon20Like, Icon20LikeOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo, MouseEventHandler, useCallback } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';
import { sendGa } from 'reactApp/utils/ga';

import styles from './Favorite.css';

interface FavoriteProps {
    className?: string;
    isFavorite?: boolean;
    isAvailable?: boolean;
    onClick?: MouseEventHandler<HTMLDivElement>;
}

export const Favorite = memo<FavoriteProps>(function Favorite({ isFavorite = false, isAvailable = true, onClick, className }) {
    const handleFavoriteClick: MouseEventHandler<HTMLDivElement> = useCallback(
        (e) => {
            e.stopPropagation();
            e.preventDefault();
            e.nativeEvent.stopImmediatePropagation();

            sendGa('datalist-control', 'click', 'favorite', EViewMode.list);

            onClick?.(e);
        },
        [onClick]
    );

    if (!isAvailable) {
        return null;
    }

    return (
        <Hint text={isFavorite ? 'Убрать из избранных' : 'Добавить в избранные'}>
            <DataListControl.New
                id="favorite-icon"
                type="favorite"
                viewType={EViewMode.list}
                className={classNames(styles.root, className, {
                    [styles.favorite]: isFavorite,
                })}
                onClick={handleFavoriteClick}
            >
                {isFavorite ? <Icon20Like /> : <Icon20LikeOutline />}
            </DataListControl.New>
        </Hint>
    );
});
